exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-view[data-v-50abc1c2]{padding-bottom:8px;padding-top:8px;user-select:none}", ""]);

// exports
